import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getBuses } from '../../../../api/shuttleSetting.api';
import useAxios from '../../../../hooks/useAxios';
import { IBus, IGetBuses } from '../../../../models/shuttleSetting.model';
import { RootState } from '../../../../store/rootReducer';
import Button from '../../../Button';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import config from '../../../../lib/config';
import Pagination from '../../../Pagination';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  scheduleIndex: number;
  onSetSchedule: (index: number, key: string, value: string) => void;
}

const SelectBusModal: FC<IProps> = ({
  visible,
  setVisible,
  scheduleIndex,
  onSetSchedule,
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetBuses>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    execute(getBuses(currentCampus));
  }, [currentCampus]);

  const columns: TableColumnsType<IBus> = [
    {
      title: t('campus.shuttle.column1'),
      dataIndex: 'busName',
      key: 'busName',
      align: 'center',
      sorter: (a, b) => a.busName?.localeCompare(b.busName),
    },
    {
      title: t('campus.shuttle.column2'),
      dataIndex: 'driverName',
      key: 'driverName',
      align: 'center',
      sorter: (a, b) => a.driverName?.localeCompare(b.driverName),
    },
    {
      title: t('campus.shuttle.column3'),
      dataIndex: 'busNo',
      key: 'busNo',
      align: 'center',
      sorter: (a, b) => a.busNo?.localeCompare(b.busNo),
    },
    {
      title: '',
      dataIndex: 'busCode',
      key: 'busCode',
      align: 'center',
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>	
          <Button
            className="btn-basic small mint"
            onClick={() => {
              if (scheduleIndex < 0) return;
              onSetSchedule(scheduleIndex, 'busCode', value);
              onSetSchedule(scheduleIndex, 'busNo', record.busNo);
              setVisible(false);
            }}
            text={t('common.button.select')}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('campus.shuttle.title6')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <Table
          className='comm-table__area mt-0'
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: page,
            pageSize: config.smallPageSize,
          }}
          rowKey="busCode"
        />
        <div className="comm-bx__between">
          <div className="common-paging center">
            <Pagination
              count={res?.data.length || 0}
              page={page}
              setPage={setPage}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SelectBusModal;
